// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-update-task-patient.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm($task_id: uuid!, $patient_id: uuid!) {
  update_tasks_tasks_by_pk(
    pk_columns: { id: $task_id }
    _set: {
      resource_schema: "vaxiom"
      resource_table: "patients"
      resource_id: $patient_id
    }
  ) {
    id
  }
}

`